import ReactDOM from "react-dom/client";

import App from "./App";
import "./styles/index.css";
import { registerWorkbox } from "./utils/workboxRegistration";

// Register service worker with Workbox (handles updates and reload)
registerWorkbox();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);
